import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/embedded_checkout_page/$eventId')({
  component: EmbeddedCheckoutPageRedirect,
});

function EmbeddedCheckoutPageRedirect() {
  const navigate = useNavigate();
  const { eventId } = Route.useParams();

  useEffect(() => {
    // Redirect to the event details page
    navigate({
      to: '/events/$eventId',
      params: { eventId },
      replace: true,
    });
  }, [eventId, navigate]);

  // Show nothing while redirecting
  return null;
}
